import { VStack, HomeCard, Spacing, colors } from "goi_common";
import { Box } from "@chakra-ui/react";

export default function HomeV4SafeSection({
  color = colors.orange650,
}: {
  color?: string;
}) {
  return (
    <VStack padding="120px 20px 0px 20px">
      <VStack
        alignItems="center"
        css={{
          textAlign: "center",
        }}
      >
        <Box className="subtitle_21_sb" color={colors.gray900}>
          고객님의 납입금은{" "}
          <b
            css={{
              color,
            }}
          >
            안전하게
          </b>
          <br />
          해지는 위약금 없이{" "}
          <b
            css={{
              color,
            }}
          >
            100% 환급
          </b>
        </Box>
      </VStack>

      <Spacing gap={24} />

      <HomeCard
        icon={{ name: "icon_Graphic_Shield", size: 40 }}
        title="고객의 돈을 안전하게 보관해요"
        buttonText="고이는 업계 최초 벤처 투자 유치 등을 통해 안정적으로 운영 중입니다. 또한, 고객님의 소중한 선수금은 제 1금융권인 국민은행에 안전하게 보관됩니다."
      />
      <Spacing gap={16} />
      <HomeCard
        icon={{ name: "icon_Graphic_RotateCoin", size: 40 }}
        title="중도 해지 시 100% 환급해 드려요"
        buttonText="고이는 복잡한 산식 대신 누적 납입금 전액을 전액 환급해 드립니다. 아직 이용하지 않은 서비스의 비용을 받지 않는 것은 당연한 일이니까요."
      />
    </VStack>
  );
}
